module.exports = __webpack_public_path__ + "media/images/sp/brands/aqua/store_yokohama-650d51f5bd0c48b10f7f17323c367b96.jpg";